(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function initKit(root) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var oneTimePct = parseFloat(root.getAttribute('data-one-time-pct')) || 0;
    var subPct = parseFloat(root.getAttribute('data-sub-pct')) || 0;
    var minItems = parseInt(root.getAttribute('data-min-items'), 10) || 1;
    var redirect = root.getAttribute('data-redirect') || '/cart';
    var kitToken = 'kit-' + Math.random().toString(36).slice(2, 10);
    var kitLabel = root.getAttribute('data-kit-label') || 'Kit';

    var qtys = Array.prototype.slice.call(root.querySelectorAll('[data-kkb-qty]'));
    var addBtn = root.querySelector('[data-kkb-add]');
    var note = root.querySelector('[data-kkb-note]');
    var elCount = root.querySelector('[data-kkb-count]');
    var elRegular = root.querySelector('[data-kkb-regular]');
    var elSaveRow = root.querySelector('[data-kkb-save-row]');
    var elSaveLabel = root.querySelector('[data-kkb-save-label]');
    var elSave = root.querySelector('[data-kkb-save]');
    var elTotal = root.querySelector('[data-kkb-total]');
    var modeInputs = Array.prototype.slice.call(root.querySelectorAll('[data-kkb-mode]'));

    function currentMode() {
      for (var i = 0; i < modeInputs.length; i++) { if (modeInputs[i].checked) return modeInputs[i].value; }
      return 'onetime';
    }

    function clampQty(input) {
      var max = parseInt(input.getAttribute('max'), 10);
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      if (!isNaN(max) && val > max) val = max;
      input.value = val;
      return val;
    }

    function recalc() {
      var count = 0, regular = 0, missingPlan = false;
      qtys.forEach(function (input) {
        var q = clampQty(input);
        if (q > 0) {
          count += q;
          regular += q * (parseInt(input.getAttribute('data-price'), 10) || 0);
          if (!input.getAttribute('data-selling-plan')) missingPlan = true;
        }
      });

      var mode = currentMode();
      var eligible = count >= minItems;
      var pct = mode === 'subscribe' ? subPct : oneTimePct;
      var effPct = eligible ? pct : 0;
      var save = Math.round(regular * effPct / 100);
      var total = regular - save;

      elCount.textContent = String(count);
      elRegular.textContent = count ? money(regular, currency) : '—';
      elTotal.textContent = count ? money(total, currency) : '—';

      if (save > 0) {
        elSaveRow.hidden = false;
        if (elSaveLabel) elSaveLabel.textContent = 'Kit saving (' + pct + '%)';
        elSave.textContent = '−' + money(save, currency);
      } else {
        elSaveRow.hidden = true;
      }

      var canAdd = count > 0;
      var msg = '';
      if (count === 0) {
        msg = 'Add at least ' + minItems + ' items to build your kit.';
      } else if (count < minItems) {
        msg = 'Add ' + (minItems - count) + ' more to unlock the ' + oneTimePct + '% kit discount.';
      } else if (mode === 'subscribe' && missingPlan) {
        msg = 'Remove items marked one-time only to subscribe, or switch to One-time.';
        canAdd = false;
      } else if (mode === 'subscribe') {
        msg = 'Subscribing: ' + subPct + '% off, auto-refills monthly at the same price.';
      } else {
        msg = "You are saving " + pct + '% (' + money(save, currency) + ') vs buying separately.';
      }
      note.textContent = msg;
      addBtn.disabled = !canAdd;
    }

    function step(input, delta) {
      var max = parseInt(input.getAttribute('max'), 10);
      var val = (parseInt(input.value, 10) || 0) + delta;
      if (val < 0) val = 0;
      if (!isNaN(max) && val > max) val = max;
      input.value = val;
      recalc();
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var dec = t.closest('[data-kkb-dec]');
      var inc = t.closest('[data-kkb-inc]');
      if (dec) { var i1 = dec.parentNode.querySelector('[data-kkb-qty]'); if (i1) step(i1, -1); }
      if (inc) { var i2 = inc.parentNode.querySelector('[data-kkb-qty]'); if (i2) step(i2, 1); }
    });
    qtys.forEach(function (input) { input.addEventListener('input', recalc); input.addEventListener('change', recalc); });
    modeInputs.forEach(function (m) { m.addEventListener('change', recalc); });

    addBtn.addEventListener('click', function () {
      var mode = currentMode();
      var items = [];
      qtys.forEach(function (input) {
        var q = parseInt(input.value, 10) || 0;
        if (q > 0) {
          var item = {
            id: parseInt(input.getAttribute('data-variant-id'), 10),
            quantity: q,
            properties: { _kit: kitLabel, _kit_id: kitToken }
          };
          var plan = input.getAttribute('data-selling-plan');
          if (mode === 'subscribe' && plan) { item.selling_plan = parseInt(plan, 10); }
          items.push(item);
        }
      });
      if (!items.length) return;

      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      }).then(function () {
        window.location.href = redirect;
      }).catch(function (err) {
        addBtn.disabled = false;
        addBtn.textContent = original;
        note.textContent = (err && (err.description || err.message)) || 'Sorry, we could not add the kit to your cart.';
      });
    });

    recalc();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-kkb]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__kkbInit) continue;
      roots[i].__kkbInit = true;
      initKit(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
